// extracted by mini-css-extract-plugin
export default {"main":"MetricsSection_main__nCZzm"};